import { Card, Col } from 'react-bootstrap'
import sData from '../../DynamicData/ServiceData.js'
const Services = () => {
    return (
        <>
            <div id="services" className="Services position-relative overflow-hidden p-3 p-md-3 text-center">
                <div className="col-md-11 p-lg-5 mx-auto my-5 fw-bold">
                    <h2 className="display-5 fw-bolder mb-4 text-center text-danger Services-title"
                        data-aos="zoom-in">Our Services</h2>
                    <p className="lead" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">Bluecoder provides best Website Design, Web Development and It Services in Nagpur. Bluecoder offers all kind of services that are required for software applications and websites that yield considerable results for any company. We are providing top quality services in Nagpur as follows.</p>
                    <div className="row d-flex justify-content-between">
                        {sData.map((data) => (
                            <Col xs={10} md={6} lg={4} className="my-3 mx-auto" key={data.id}>
                                <Card className="p-3 cards" data-aos="flip-right" data-aos-delay="300" data-aos-duration="1000">
                                    <Card.Body>
                                        <Card.Title className="m-3">{data.icon}</Card.Title>
                                        <Card.Title className="service_title">{data.service}</Card.Title>
                                        <Card.Text className="my-3 service_desc">{data.desc}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </div>

                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Services